import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchProductList } from "./productTypesAPI";
import { ProductTypesState } from "../../../features/view/public/landingPage/landingPageTypes";

const initialState: ProductTypesState = {
  productTypes: { data: [], loader: false },
};

export const getProductListAsync = createAsyncThunk(
  "productTypes/get",
  async () => {
    const response = await fetchProductList();
    return response;
  }
);

export const productTypesSlice = createSlice({
  name: "productTypes",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getProductListAsync.pending, (state) => {
        state.productTypes.loader = true;
      })
      .addCase(getProductListAsync.fulfilled, (state, action: any) => {
        state.productTypes.loader = false;
        state.productTypes.data = action?.payload?.data || [];
      })
      .addCase(getProductListAsync.rejected, (state) => {
        state.productTypes.loader = false;
      });
  },
});
// export const { } = productTypesSlice.actions;

export default productTypesSlice.reducer;
